<template>
  <div
    id="select-option"
    class="option-btn"
    @click="handleClick"
    :class="(active || selected) && 'active'"
  >
    <div class="row row-cols-2 flex-fill">
      <div class="col-2 text-center ms-3 p-3 img-container">
        <img :src="icon" alt="icon" class="mx-auto d-block my-auto" />
      </div>
      <div class="col col-8 my-auto ms-2">
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref, watch } from "vue";
import TransactionFilter from "@/apps/credit-line/types/TransactionFilter";
export default defineComponent({
  name: "TransactionFilterOption",
  components: {},
  emits: ["update:value"],
  props: {
    text: String,
    icon: String,
    value: Object as PropType<TransactionFilter>,
    name: String,
    selected: Boolean,
  },
  setup(props, { emit }) {
    const active = ref<boolean>(false);

    const handleClick = () => {
      emit("update:value", { id: props.name, text: props.text });
    };

    onMounted(() => {
      active.value = props.value?.id === props.name;
    });

    watch(
      () => props.value?.id,
      (newValue) => {
        active.value = newValue === props.name;
      }
    );

    return { active, handleClick };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global";
.option-btn {
  cursor: pointer;
  background: white;
  color: black;
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}

.option-btn .img-container {
  display: flex;
  width: 56px;
  height: 56px;
  padding: 12px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  border: 1px solid var(--borders-default, #eee);
  background: var(--background-grey-100, #fbfbfb);
}

.option-btn span {
  font-weight: 600;
  letter-spacing: 0;
}

.active {
  border-radius: 10px;
  background: var(--main-primary-300, #d5efd4);
}

.active .img-container {
  border: none;
  background: transparent;
}
#select-option {
  width: 100%;
}
img {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
</style>
